import React, { FC, useEffect, useState } from "react";
import { SelectableCheckbox } from "../../models/checkbox/SelectableCheckbox";
import { generateFieldId } from "../../utilities/GenerateFieldId";

export interface CheckboxFieldProps {
    onSelect: (event, option) => void;
    option: SelectableCheckbox;
    compact?: boolean;
    image?: any;
    disabled?: boolean;
}

const CheckboxField: FC<CheckboxFieldProps> = ({ onSelect, option, compact = false, image = undefined, disabled = false }) => {
    const [checked, setChecked] = useState(option.isSelected);

    useEffect(() => {
        setChecked(option.isSelected);
    }, [option.isSelected])

    const handleSelection = (event) => {
        if (disabled) return;
        onSelect(event,option);
        // setChecked(option.isSelected);
    }

    const containerBaseClass = compact
        ? "checkboxListField--container--compact p-1"
        : "border-gray-300 border-solid border-l-2 border-r-2 border-b-2 checkboxListField--container p-2";

    return (
        <span onClick={handleSelection}
            className={`flex flex-row items-center ${containerBaseClass} ${disabled ? 'disabled' : ''}`}>
            <input id={generateFieldId(option.label, 'CheckBox')}
                className="pr-2"
                type="checkbox"
                onChange={() => {}}
                checked={checked}
                disabled={disabled} />
            <span  data-cy={generateFieldId(option.label, 'CheckBox')} className={compact ? 'checkboxListField--checkmark--compact' : 'checkboxListField--checkmark'}></span>
            &nbsp;  
            {image
                ? <>
                    <img src={image} className="w-4 mr-1" alt="" />
                    &nbsp;
                </>
                : null}
            {option.label}
        </span>
    );
};

export default CheckboxField;
